/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'majestic',
    quality: 0.9,
    perception: 2,
    strength: 2,
    willpower: 2,
    magicalGravity: 0.3
}